import React, { useState, useContext } from 'react'
import {
    Stack,
    FormControl,
    useColorModeValue,
    GridItem,
    FormLabel,
    Flex,
    Heading,
    Text,
    Button,
    useToast,
    Spinner,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import UserContext from "../State/UserContext";

export default function Facturacion() {
    const [archivoDetalleFileList, setArchivoDetalleFileList] = useState([]);
    const [facturaFileList, setFacturaFileList] = useState([]);
    const [historiasClinicasfileList, setHistoriasClinicasFileList] = useState([]);
    const [uploading, setuploading] = useState(false);
    const [uploadStatusAlert, setUploadStatusAlert] = useState();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { user } = useContext(UserContext);
    const toast = useToast()
    const MAX_HC_FILES = 10;

    async function handleUpload() {
        setuploading(true);
        setUploadStatusAlert(null);

        const hasArchivoDetalle = archivoDetalleFileList.length > 0;
        const hasFactura = facturaFileList.length > 0;

        if (!hasArchivoDetalle && !hasFactura) {
            setUploadStatusAlert(
                <Alert status="warning" borderRadius="5px">
                    <AlertIcon />
                    Debe seleccionar Archivo de detalle o Factura.
                </Alert>
            );
            setuploading(false);
            return;
        }

        const archivoDetalle = hasArchivoDetalle ? archivoDetalleFileList[0] : null;
        const factura = hasFactura ? facturaFileList[0] : null;

        try {
            const [detalleBase64, facturaBase64, historiasClinicas] = await Promise.all([
                archivoDetalle ? getBase64Data(archivoDetalle) : Promise.resolve(null),
                factura ? getBase64Data(factura) : Promise.resolve(null),
                Promise.all(
                    historiasClinicasfileList.map(async file => ({
                        archivoFile: file.name,
                        archivoBase64: await getBase64Data(file),
                        tipoDocumento: "HC"
                    }))
                )
            ]);

            const detalles = [
                ...(archivoDetalle ? [{
                    archivoFile: archivoDetalle.name,
                    archivoBase64: detalleBase64,
                    tipoDocumento: "AD"
                }] : []),
                ...(factura ? [{
                    archivoFile: factura.name,
                    archivoBase64: facturaBase64,
                    tipoDocumento: "FA"
                }] : []),
                ...historiasClinicas
            ];

            // REQUEST FINAL
            const request = {
                idUsuario: user.user?.id,
                email: user.user?.email,
                providerCuit: user.user?.providerCuit,
                prestador: user.user?.prestadorId,
                providerName: user.user?.providerName,
                detalles
            };


            const response = await fetch("facturacion/uploadFacturacion", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    //Authorization: `Bearer ${user.token}`,
                    USERTOKEN: user.token,
                },
                body: JSON.stringify(request)
            });
            if (!response.ok) {
                var msg = response.status === 413 ? "Los archivos no pueden superar los 40 mb" : "Ocurrio un error al subir los archivos"
                setUploadStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                    { msg }
                    </Alert>
                );
                setuploading(false);
                return;
            }

            setUploadStatusAlert(null);
            setArchivoDetalleFileList([]);
            setFacturaFileList([]);
            setHistoriasClinicasFileList([]);

            toast({
                title: "Exito!.",
                description: "Los archivos fueron subidos correctamente.",
                status: "success",
                duration: 5000,
                isClosable: true,
            })

        } catch (err) {
            setUploadStatusAlert(
                <Alert status="error">
                    <AlertIcon />
                    {err.message}
                </Alert>
            );
        }

        setuploading(false);
    }

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const getBase64Data = async (file) => {
        let base64 = await toBase64(file);
        return base64.split("base64,")[1];
    };

    const propsArchivoDetalle = {
        onRemove: file => {
            const index = archivoDetalleFileList.indexOf(file);
            const newFileList = archivoDetalleFileList.slice();
            newFileList.splice(index, 1);
            setArchivoDetalleFileList(newFileList);
        },
        beforeUpload: file => {
            if (!file.type.includes("text") && !file.type.includes("sheet")) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            setArchivoDetalleFileList([file]);
            setUploadStatusAlert("");
            return false;
        },
        archivoDetalleFileList,
    };

    const propsFactura = {
        onRemove: file => {
            const index = facturaFileList.indexOf(file);
            const newFileList = facturaFileList.slice();
            newFileList.splice(index, 1);
            setFacturaFileList(newFileList);
        },
        beforeUpload: file => {
            if (!file.type.includes("pdf")) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            setFacturaFileList([file]);
            setUploadStatusAlert("");
            return false;
        },
        facturaFileList,
    };

    const propsHisoriasClinicas = {
        onRemove: file => {
            const index = historiasClinicasfileList.indexOf(file);
            const newFileList = historiasClinicasfileList.slice();
            newFileList.splice(index, 1);
            setHistoriasClinicasFileList(newFileList);
        },
        beforeUpload: file => {
            //if (!file.type === "" && !file.type.includes("pdf") && !file.type.includes("zip")) {
            if (file.type && !file.type.includes("pdf") && !file.type.includes("zip")) {
                setUploadStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }

            // VALIDAR MÁXIMO DE ARCHIVOS
            if (historiasClinicasfileList.length >= MAX_HC_FILES) {
                setUploadStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        Solo puedes subir un máximo de {MAX_HC_FILES} archivos de historias clínicas.
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }

            setHistoriasClinicasFileList([...historiasClinicasfileList, file]);
            setUploadStatusAlert("");
            return false;
        },
        historiasClinicasfileList,
    };

    return (
        <Flex
            minH="100vh"
            alignItems="flex-start"
            justifyContent="center"
            backgroundColor="gray.100"
            py={10} 
        >
            <Stack
                boxShadow="xl"
                bg={useColorModeValue('white', 'gray.600')}
                rounded={'xl'}
                p={10}
                spacing={8}
                align={'stretch'}
                maxH="85vh"
                overflowY="auto"
                >
                <Button marginLeft="auto" onClick={() => { onOpen() }}>
                    Info
                </Button>
                <Stack align={'center'} spacing={2}>
                    <Heading
                        textTransform={'uppercase'}
                        fontSize={'3xl'}
                        color={useColorModeValue('gray.600', 'gray.200')}>
                        Carga de Facturación
                    </Heading>
                    <Text textAlign="center" fontSize={'lg'} color={'gray.600'}>
                        Complete todos los campos para presentar la documentacion de facturación de su entidad.
                    </Text>
                </Stack>
                <FormControl as={GridItem} colSpan={[6, 3]}>
                    <FormLabel
                        for="tipoDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Archivo de detalle
                    </FormLabel>
                    <Upload fileList={archivoDetalleFileList} accept=".txt, .xlsx, .xls" {...propsArchivoDetalle} maxCount={1}>
                        <Button icon={<UploadOutlined />}>Seleccione archivo</Button>
                    </Upload>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <FormLabel
                        for="numDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Factura
                    </FormLabel>
                    <Upload fileList={facturaFileList} accept=".pdf" {...propsFactura} maxCount={1}>
                        <Button icon={<UploadOutlined />}>Seleccione archivo</Button>
                    </Upload>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <FormLabel
                        for="numDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Historias Clinicas
                    </FormLabel>
                    <Upload fileList={historiasClinicasfileList} accept=".rar, .pdf, .zip" {...propsHisoriasClinicas}>
                        <Button icon={<UploadOutlined />}>Seleccione archivos</Button>
                    </Upload>
                    <Text fontSize="sm" color="gray.500">
                        {historiasClinicasfileList.length} / {MAX_HC_FILES} archivos
                    </Text>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <Button
                        borderRadius="8px"
                        variant="solid"
                        type="primary" color="#004990"
                        width="full"
                        onClick={handleUpload}
                        loading={uploading}
                        style={{ marginTop: 16 }}
                        disabled={uploading}
                    >
                        {uploading ? <Spinner color="#004990" /> : 'Subir'}
                    </Button>
                </FormControl>
                <Modal size={"xl"} isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Instructivo Carga de Archivos (Facturación)</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <p>Se deberá realizar la carga de la documentación de la facturación ambulatoria y luego la facturación internados por separado (cargas individuales).</p>
                            <br></br>
                            <p><b>Archivo de Detalle</b>: El tipo de documento cargado debe ser TXT y el archivo cargado deberá tener el siguiente nombre o nomenclatura; la primera letra identifica si es un archivo de Ambulatorio (A) o un archivo de Internación (I); la segunda letra identifica el tipo de factura (Puede ser A o C); los números son los identificatorios de la factura; y el archivo siempre debe terminar en “_01”.</p>
                            <p>Ejemplos:</p>
                            <ul style={{ marginLeft: 50 }}>
                                <li><b>AxxxxxAxxxxxxxx_01</b> donde la primera <b>A</b> significa que es un archivo de detalle para Ambulatorio; la segunda letra representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura; y el archivo siempre debe terminar en “_01”. <b>Ejemplo</b>: A12345A12345678_01</li>
                                <li><b>IxxxxxAxxxxxxxx_01</b> donde la primera <b>I</b> significa que es un archivo de detalle para Internación; la segunda letra representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura; y el archivo siempre debe terminar en “_01”. <b>Ejemplo</b>: I12345A12345678_01</li>
                            </ul>
                            <p><b>Factura</b>: El tipo de documento cargado debe ser PDF y el archivo cargado deberá tener un nombre o nomenclatura parecido al que se utiliza para el archivo de detalle; se escribe una letra que identifica el tipo de factura y los otros caracteres identifican a la factura. Adicionalmente, la nomenclatura de la factura debe coincidir con la del archivo TXT cargado.</p>
                            <ul style={{ marginLeft: 50 }}>
                                <li><b>xxxxxAxxxxxxxx</b> donde la letra cargada representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura. <b>Ejemplo</b>: 12345A12345678</li>
                                <li><b>xxxxxCxxxxxxxx</b> donde la letra cargada representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura. <b>Ejemplo</b>: 12345C12345678</li>
                                <li>La nomenclatura del archivo de detalle y la factura deben coincidir. Si el usuario carga un Archivo de detalle nombrado <b>A</b>44444<b>A</b>55558888_01, la factura adjuntada debe tener como nombre 44444<b>A</b>55558888.</li>
                                <li>En caso de que los nombres no coincidan, el portal impedirá subir la documentación.</li>
                            </ul>
                            <p><b>Historias Clínicas</b>: Es un campo que permite al usuario cargar un archivo PDF o un conjunto de archivos comprimidos en formato .RAR o .ZIP.</p>
                            <br></br>
                            <p><b>Nota</b>: El conjunto de archivos enviados (Archivo Detalle, Factura, Historias clínicas) no debe ser mayor a 40mb.</p>
                            <br></br>
                            <p>Ante cualquier duda o complicación en la carga de documentos enviar correo electrónico a la casilla liquidacionesdelplandesalud@hbritanico.com.ar</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="blue" mr={3} onClick={onClose}>
                                Cerrar
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                {uploadStatusAlert}
            </Stack>
        </Flex >
    )
}